import {
  faDownload,
  faMagnifyingGlass,
  faNetworkWired,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { t as globalT } from "@lingui/core/macro";
import { Trans } from "@lingui/react/macro";
import { Center, Container, Grid, Stack, Title } from "@mantine/core";
import { AnchorLink } from "@sweco-se/reality-frontend";
import { createFileRoute } from "@tanstack/react-router";

import { FEATURES } from "@/constants.ts";

export const Route = createFileRoute("/")({
  component: App,
  head: () => ({
    meta: [
      {
        title: globalT`Sweco REALity`,
      },
    ],
  }),
});

function App() {
  return (
    <Container>
      <Grid justify="center">
        <Grid.Col span={12} component={Center}>
          <Title order={1} my="lg">
            <Trans>What do you want to do?</Trans>
          </Title>
        </Grid.Col>
        {FEATURES.includes("extraction") && (
          <Grid.Col span={{ md: 4 }}>
            <AnchorLink to="/flows/download/choose-project">
              <Stack
                bdrs="lg"
                bg="var(--mantine-color-green-0)"
                px="md"
                align="center"
                justify="center"
                style={{ aspectRatio: 1 }}
              >
                <FontAwesomeIcon
                  icon={faDownload}
                  size="5x"
                  color="var(--mantine-color-green-6)"
                />
                <Title order={5} mt="lg">
                  <Trans>Download data</Trans>
                </Title>
              </Stack>
            </AnchorLink>
          </Grid.Col>
        )}
        {FEATURES.includes("property-search") && (
          <Grid.Col span={{ md: 4 }}>
            <AnchorLink to="/property/search">
              <Stack
                bdrs="lg"
                bg="var(--mantine-color-blue-0)"
                px="md"
                align="center"
                justify="center"
                style={{ aspectRatio: 1 }}
              >
                <FontAwesomeIcon
                  icon={faMagnifyingGlass}
                  size="5x"
                  color="var(--mantine-color-blue-6)"
                />
                <Title order={5} mt="lg">
                  <Trans>Search for property information</Trans>
                </Title>
              </Stack>
            </AnchorLink>
          </Grid.Col>
        )}
        {FEATURES.includes("gis-connection") && (
          <Grid.Col span={{ md: 4 }}>
            <AnchorLink to="/docs/platform/access">
              <Stack
                bdrs="lg"
                bg="var(--mantine-color-gray-0)"
                px="md"
                align="center"
                justify="center"
                style={{ aspectRatio: 1 }}
              >
                <FontAwesomeIcon
                  icon={faNetworkWired}
                  size="5x"
                  color="var(--mantine-color-gray-6)"
                />
                <Title order={5} mt="lg">
                  <Trans>Connect my GIS</Trans>
                </Title>
              </Stack>
            </AnchorLink>
          </Grid.Col>
        )}
      </Grid>
    </Container>
  );
}
